import { Outlet } from 'react-router-dom';

import { DemoNavLinks } from '@/screens/demo/DemoRoutes.tsx';

export const DemoLayout = () => {
	return (
		<div
			className="relative z-10 flex h-screen w-full flex-col gap-8
				overflow-y-auto p-8"
		>
			<nav className="z-1 mb-4 flex gap-4">
				<DemoNavLinks />
			</nav>
			<Outlet />
		</div>
	);
};
